
import devConfig from './envConfig/dev.config.js';
import prodConfig from './envConfig/prod.config.js';
import stageConfig from './envConfig/stage.config.js';
const env = process.env.REACT_APP_ENV || 'development';

console.log("Environment inside configjs file", env);

const config = {
  development: devConfig,
  production: prodConfig,
  stage: stageConfig,
};

export default config[env];